import { EnvironmentProviders, Provider } from '@angular/core';
import { provideStore } from './store/store.providers';
import { provideResources } from './data/resource.providers';
import { sortProviders } from './sort/sort.providers';
import { Logger } from './log/logger';
import { Mediator } from './mediator/mediator';
import { filterProviders } from './filter/filter.providers';
import { telemetryProviders } from './telemetry/telemetry.providers';
import { SOFTLINE_CONFIG_COOKIE_PREFIX, SOFTLINE_SERVICE_HTTP, SOFTLINE_SERVICE_UUID } from './core.shared';
import { ConnectionHttpService } from './data/specialized/http/connection-http.service';
import { WrappedResourceService } from './data/specialized/wrapped-resource.service';
import { ResponseResult } from './data/specialized/http/response-result';
import { uuid } from './functions/uuid.function';

export const provideCore: () => Array<Provider | EnvironmentProviders> = () => {
  return [
    provideStore([]),
    provideResources(),

    Logger,
    Mediator,

    filterProviders,
    sortProviders,
    telemetryProviders,

    { provide: SOFTLINE_CONFIG_COOKIE_PREFIX, useValue: 'Softline' },
    { provide: SOFTLINE_SERVICE_UUID, useValue: () => uuid() },
    {
      provide: SOFTLINE_SERVICE_HTTP,
      useFactory: (service: ConnectionHttpService) =>
        new WrappedResourceService(
          service,
          (response: ResponseResult<any>) => response?.result
        ),
      deps: [ConnectionHttpService],
    },
    ];
}
